import {
  IMobileOrchestrator,
  IMobileReactivationOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { IServiceStatus } from "@nju/data-access-portal-product";
import { IMnpPortoutTask } from "@nju/data-access-portal-service";
import { IMobileServiceCTABannerConditions } from "./types";

interface IGetMobileServiceCTABannerConditionsProps {
  serviceStatus?: IServiceStatus["mobileServiceStatus"];
  portoutData?: IMnpPortoutTask["properties"] | undefined;
  orchestrator?: IMobileOrchestrator | IMultiOrderOrchestrator | undefined;
  reactivationOrchestratorState?:
    | IMobileReactivationOrchestrator["state"]
    | undefined;
}

export function getMobileServiceCTABannerConditions({
  serviceStatus,
  portoutData,
  orchestrator,
  reactivationOrchestratorState,
}: IGetMobileServiceCTABannerConditionsProps): IMobileServiceCTABannerConditions {
  return {
    isPendingCancellation: serviceStatus === "PendingCancellation",
    isPortoutCancellationPossible:
      portoutData?.npSubState === "Cancellation possible",
    isPortoutCancellationNotPossible:
      portoutData?.npSubState === "Cancellation impossible",
    isPortoutCancellationCheckInProgress:
      portoutData?.npSubState === "Cancellation in progress",
    isNoPayment: serviceStatus === "NoPayment",
    isSuspended:
      orchestrator?.state === "COMPLETED" &&
      (reactivationOrchestratorState === undefined ||
        reactivationOrchestratorState === "START") &&
      serviceStatus === "Suspended",
    isPendingReactivation:
      orchestrator?.state === "COMPLETED" &&
      !!reactivationOrchestratorState &&
      reactivationOrchestratorState !== "START" &&
      (serviceStatus === "Suspended" || serviceStatus === "Disconnected"),
    isPendingTermination: serviceStatus === "PendingTermination",
    isUnsubscribed: serviceStatus === "Unsubscribed",
    isDisconnected:
      orchestrator?.state === "COMPLETED" &&
      (reactivationOrchestratorState === undefined ||
        reactivationOrchestratorState === "START") &&
      serviceStatus === "Disconnected",
  };
}
